<mat-toolbar color="primary" class="footer">
  <div class="footer-container flex flex-col md:flex-row pb-8 md:pb-0">
    <div>
      <a i18n routerLink="/imprint">Impressum</a>
      <div class="flex items-center">
        <label class="mr-2" i18n="@@languageSelection" for="languageSelection"
          >Sprachauswahl:</label
          >

          <select
            class="rounded p-2 font-bold underline appearance-none outline-none bg-transparent"
            [(ngModel)]="currentLanguage"
            (change)="onLanguageChange($event)"
            >
            @for (locale of localesList; track locale) {
              <option [value]="locale.code">
                {{ locale.label }}
              </option>
            }
          </select>
        </div>
        <p>© Lebensbegleitung – Life Care eGen</p>
      </div>
      <!-- <div class="flex flex-row">
      <a
        href="https://www.linkedin.com/in/lebensbegleitung-lifecare-43b17725b/"
        target="_blank"
        ><svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        >
        <path
          d="M19,3H5C3.895,3,3,3.895,3,5v14c0,1.105,0.895,2,2,2h14c1.105,0,2-0.895,2-2V5C21,3.895,20.105,3,19,3z M9,17H6.477v-7H9 V17z M7.694,8.717c-0.771,0-1.286-0.514-1.286-1.2s0.514-1.2,1.371-1.2c0.771,0,1.286,0.514,1.286,1.2S8.551,8.717,7.694,8.717z M18,17h-2.442v-3.826c0-1.058-0.651-1.302-0.895-1.302s-1.058,0.163-1.058,1.302c0,0.163,0,3.826,0,3.826h-2.523v-7h2.523v0.977 C13.93,10.407,14.581,10,15.802,10C17.023,10,18,10.977,18,13.174V17z"
        ></path></svg
      ></a>
      <a
        href="https://www.facebook.com/profile.php?id=100088712775519>"
        target="_blank"
        ><svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        >
        <path
          d="M19,3H5C3.895,3,3,3.895,3,5v14c0,1.105,0.895,2,2,2h7.621v-6.961h-2.343v-2.725h2.343V9.309 c0-2.324,1.421-3.591,3.495-3.591c0.699-0.002,1.397,0.034,2.092,0.105v2.43h-1.428c-1.13,0-1.35,0.534-1.35,1.322v1.735h2.7 l-0.351,2.725h-2.365V21H19c1.105,0,2-0.895,2-2V5C21,3.895,20.105,3,19,3z"
        ></path></svg
      ></a>
      <a
        href="https://www.instagram.com/lebensbegleitunglifecare/?igsh=dmQxdmp1aWMwamUx"
        target="_blank"
        ><svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        >
        <path
          fill="currentColor"
          d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"
        ></path></svg
      ></a>
    </div> -->
  </div>
</mat-toolbar>
